import React from "react";
import styled from "./Email.module.css";
const Email = () => {
	return (
		<div className={styled.margin}>
			<h3 className={styled.color}>atulkr.9818@gmail.com</h3>
		</div>
	);
};

export default Email;
